import React, { useState, useRef, useEffect } from "react";
import heroImage1 from "../assets/slider-main-business-is-jet-terminal-sabiha-gokcen-ic-01.jpg";
import heroImage2 from "../assets/slider-main-business-is-jet-terminal-sabiha-gokcen-ic-01.jpg";
import heroImage3 from "../assets/slider-main-business-is-jet-terminal-sabiha-gokcen-ic-01.jpg";

const heroImages = [heroImage1, heroImage2, heroImage3];
const heroHeadings = [
  ["Dünyanın Tercihi"],
  ["Dev Projelerin Mimarisi"],
  ["Yepyeni bir İnovasyon"],
];

function GirisSection() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const imageIntervalRef = useRef(null);

  // Slider otomatik geçiş efekti
  useEffect(() => {
    imageIntervalRef.current = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000);

    return () => {
      clearInterval(imageIntervalRef.current);
    };
  }, []);

  const handleButtonClick = () => {
    const targetSection = document.getElementById("hakkimizda");
    if (targetSection) {
      const offset = 80;
      const targetScrollPosition = targetSection.offsetTop - offset;
      window.scrollTo({
        top: Math.max(targetScrollPosition, 0),
        behavior: "smooth",
      });
    }
  };

  return (
    <section
      id="giris"
      className="relative w-screen h-screen flex justify-center items-center text-white text-center overflow-hidden font-sans" // font-sans eklendi
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ease-in-out"
        style={{
          backgroundImage: `url(${heroImages[currentImageIndex]})`,
          backgroundAttachment: "fixed",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          zIndex: 0,
        }}
      />

      <div className="absolute inset-0 bg-black bg-opacity-30 z-1" />

      <div className="absolute inset-0 flex flex-col justify-center items-center z-10">
        <div className="relative w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2 px-4 flex flex-col items-center justify-center">
          <h1 className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-thin leading-tight tracking-wide opacity-0 transition-opacity duration-1000 ease-in-out ${currentImageIndex !== null ? 'opacity-100' : ''}`}>
            {heroHeadings[currentImageIndex][0]}
          </h1>

           
          <div className="pt-6 mx-8" onClick={handleButtonClick}> {/* Added margin top for spacing */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-20 w-20 text-white animate-pulse" // Added animate-bounce for a subtle animation
              fill="none"
              viewBox="0 0 36 36"
              stroke="currentColor"
              strokeWidth="1"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
           

          {/* Down arrow icon */}
        </div>
      </div>
    </section>
  );
}

export default GirisSection;